<!-- 搜索组件 -->
<template>
    <div>
        <div class="card"><div class="title">{{ newFormData.name }}</div></div>
        <div class="card mb-0">
            <Menu mode="horizontal" :active-name="name_id" @on-select="selectName">
                <MenuItem name="1">样式设置</MenuItem>
                <MenuItem name="2">内容设置</MenuItem>
            </Menu>
            <div class="mt-24 mb-24">
                <div v-if="name_id == 1">
                    <Form :model="newFormData.content" label-position="left" :label-width="100">
                        <div class="form-title">搜索框设置</div>
                        <FormItem label="提示文字">
                            <Input v-model="newFormData.content.text" placeholder="请输入提示文字"></Input>
                        </FormItem>
                        <FormItem label="文字位置">
                            <RadioGroup v-model="newFormData.content.position" type="button">
                                <Radio label="left"><Icon type="md-menu"/></Radio>
                                <Radio label="center"><Icon type="md-funnel"/></Radio>
                            </RadioGroup>
                        </FormItem>
                        <FormItem label="文字颜色">
                            <ColorPicker v-model="newFormData.content.text_color"/>
                        </FormItem>
                        <FormItem label="搜索框背景">
                            <ColorPicker v-model="newFormData.content.bg_color"/>
                        </FormItem>
                        <FormItem label="搜索框边框">
                            <ColorPicker v-model="newFormData.content.border_color"/>
                        </FormItem>
                        <FormItem label="组件背景">
                            <ColorPicker v-model="newFormData.content.bgs_color"/>
                        </FormItem>
                        <FormItem label="上传图标">
                            <div class="form-upload" @click="openModal">
                                <img class="form-img" v-if="newFormData.content.imgs.picview" :style="`background-color: ${newFormData.content.bgs_color};`"
                                    :src="newFormData.content.imgs.picview"
                                />
                                <Icon v-else type="md-add" size="30" color="#ccc"/>
                            </div>
                        </FormItem>
                        <div class="form-title">按钮设置</div>
                        <FormItem label="按钮文字">
                            <Input v-model="newFormData.content.btn_text" placeholder="请输入提示文字"></Input>
                        </FormItem>
                        <FormItem label="按钮背景">
                            <ColorPicker v-model="newFormData.content.btn_bg_color"/>
                        </FormItem>
                        <FormItem label="按钮边框">
                            <ColorPicker v-model="newFormData.content.btn_border_color"/>
                        </FormItem>
                    </Form>
                </div>
                <div v-if="name_id == 2">
                    <Form :model="newFormData.content" label-position="right" :label-width="80">
                        <div class="form-title">搜索框设置</div>
                        <FormItem label="搜索框高">
                            <Input v-model="newFormData.content.height" placeholder="请输入搜索框高"></Input>
                        </FormItem>
                        <FormItem label="左右间距">
                            <Slider class="w300" v-model="newFormData.content.marginData.left"></Slider>
                        </FormItem>
                        <FormItem label="上下间距">
                            <Slider class="w300" v-model="newFormData.content.marginData.top"></Slider>
                        </FormItem>
                        <FormItem label="圆角">
                            <Slider class="w300" v-model="newFormData.content.marginData.radius"></Slider>
                        </FormItem>
                        <div class="form-title">按钮设置</div>
                        <FormItem label="按钮框高">
                            <Input v-model="newFormData.content.btn_height" placeholder="请输入按钮框高"></Input>
                        </FormItem>
                        <FormItem label="左右间距">
                            <Slider class="w300" v-model="newFormData.content.marginData.btn_left_right"></Slider>
                        </FormItem>
                        <FormItem label="上下间距">
                           <Slider class="w300" v-model="newFormData.content.marginData.btn_top_bottom"></Slider>
                        </FormItem>
                        <FormItem label="圆角">
                            <Slider class="w300" v-model="newFormData.content.marginData.btn_radius"></Slider>
                        </FormItem>
                    </Form>
                </div>
            </div>
        </div>
        <pictureLibrary
            v-if="switch_modal"
            :switch_modal.sync="switch_modal"
            :select="select"
            :select_type="select_type"
            @change="costPlannedAmountChange"
        ></pictureLibrary>
    </div>
</template>

<script>
import pictureLibrary from "@/components/picture/pictureLibrary.vue";
export default {
    components: {
        pictureLibrary,
    },
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
    },
    data() {
        return {
            select: 1,
            select_type: "image",
            switch_modal: false,
            name_id: "1",
        };
    },
    mounted() {
    },
    methods: {
        // 事件处理函数
        async costPlannedAmountChange(param1, param2) {
            for (var i = 0; i < param1.length; i++) {
                this.newFormData.content.imgs.picview = param1[i];
            }
            for (var i = 0; i < param2.length; i++) {
                this.newFormData.content.imgs.value = param2[i];
            }
            this.$Message.destroy();
        },
        openModal() {
            this.switch_modal = true;
        },
        changeBgValue(e) {
            this.newFormData.content.bgValue = e;
        },
        selectName(name) {
            this.name_id = name;
        },
    },
};
</script>

<style scoped>
.card {
    padding: 24px;
    margin-bottom: 12px;
    width: 100%;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.title {
    display: flex;
    align-items: center;
    font-weight: 500;
    font-size: 22px;
    color: #484e66;
}
.title::before {
    content: " ";
    display: block;
    width: 4px;
    height: 26px;
    margin-right: 12px;
    background: #ff761d;
}
.form-upload {
    width: 80px;
    height: 80px;
    border-radius: 5px;
    background: #ffffff;
    border: 1px solid #9fa5bb;
    display: flex;
    align-items: center;
    justify-content: center;
}
.form-img {
    width: 78px;
    height: 78px;
    border-radius: 5px;
    background: #ffffff;
    border: 1px solid #9fa5bb;
}
.form-title {
    margin: 24px 0;
    font-weight: bold;
    font-size: 15px;
    color: #484e66;
}
</style>